import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text
} from '@chakra-ui/react';
import MainLayout from 'components/layouts/MainLayout';
import dispatchToast from 'components/modules/Toast';
import {
  formatCardNumber,
  handleLinkFormSubmit
} from 'features/smart-receipt/libs';
import { membershipMemberResponseAtom } from 'libs/recoil/atom';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { LINK_PAGE_PATH } from './index';

export const LINK_FORM_PAGE_PATH = '/smart-receipt/link';

export const LinkFormPage: FC = () => {
  const navigate = useNavigate();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const membershipMemberResponse = useRecoilValue(membershipMemberResponseAtom);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id || !password) {
      return;
    }
    setIsLoading(true);
    try {
      const submitResult = await handleLinkFormSubmit({
        accountId: id,
        plainPassword: password
      });
      if (submitResult.toastText) {
        dispatchToast({
          id: 'smart-receipt-link-form',
          toastText: submitResult.toastText
        });
      }
      if (submitResult.redirectPath) {
        navigate(submitResult.redirectPath);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoBack = () => {
    navigate(LINK_PAGE_PATH);
  };

  const getMemberCardNumber = () => {
    if (
      membershipMemberResponse &&
      membershipMemberResponse.status === 'succeeded'
    ) {
      return formatCardNumber({
        cardNumber: membershipMemberResponse.data.card_number,
        groupSize: 4
      });
    }
  };

  return (
    <MainLayout pageTitle="スマートレシート連携" bg="dark.50" header footer>
      <Container px="1rem" pt="2.25rem">
        <Flex direction="column" align="center" justify="center">
          <Heading
            as="h1"
            size="lg"
            textAlign="center"
            mt={3}
            mb={4}
            color="gray.700"
          >
            スマートレシート連携
          </Heading>

          <Text fontSize="1rem" lineHeight="1.5" color="gray.600" mb={8}>
            スマートレシートに登録しているメールアドレスまたは電話番号と、パスワードを入力してください。
          </Text>

          <Box as="form" onSubmit={handleSubmit} width="100%" maxWidth="400px">
            <FormControl mb={4}>
              <FormLabel color="gray.700" fontWeight="bold">
                連携する会員番号
              </FormLabel>
              <Text fontSize="1rem" lineHeight="1.5" color="gray.600">
                {getMemberCardNumber()}
              </Text>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel color="gray.700" fontWeight="bold">
                メールアドレスまたは電話番号
              </FormLabel>
              <Input
                type="text"
                value={id}
                onChange={(e) => setId(e.target.value)}
                bg="white"
                borderColor="gray.300"
                focusBorderColor="blue.500"
                size="lg"
              />
            </FormControl>

            <FormControl mb={8}>
              <FormLabel color="gray.700" fontWeight="bold">
                パスワード
              </FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                bg="white"
                borderColor="gray.300"
                focusBorderColor="blue.500"
                size="lg"
                autoComplete="new-password"
              />
            </FormControl>

            <Flex direction="column">
              <Button
                type="submit"
                mb={4}
                variant="primary-fullwidth-rounded"
                isLoading={isLoading}
                isDisabled={!id || !password}
                size="lg"
              >
                スマートレシートと連携する
              </Button>
              <Button
                variant="primary-outline-fullwidth-rounded"
                onClick={handleGoBack}
                size="lg"
              >
                戻る
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Container>
    </MainLayout>
  );
};
